import React from "react";

function Loader(){
    return(
        <div className="member-body">
            <div class="loading"></div>
        </div>
    )
}

export default Loader;